import { FC, useEffect, useRef } from 'react';

import { BurgerMenuClose, BurgerMenuOpen, H1 } from '@smartshell/ui-kit';

import { usePageTitles } from 'hooks';
import { ONBOARDING_STEP_CHANGED_EVENT } from 'sandbox/onboarding/events';

import { NavBar } from '../NavBar';
import { NavBarMobileProps } from './interfaces';
import s from './NavBarMobile.module.scss';

export const NavBarMobile: FC<NavBarMobileProps> = ({
  activeDropdown,
  setActiveDropdown,
}) => {
  const pageTitle = usePageTitles();
  const navRef = useRef<HTMLElement>(null);
  const isOpen = activeDropdown === 'navBar';

  useEffect(() => {
    setActiveDropdown(null);
  }, [location.pathname]);

  useEffect(() => {
    const handleOnboardingStep = (): void => {
      setActiveDropdown(null);
    };

    window.addEventListener(
      ONBOARDING_STEP_CHANGED_EVENT,
      handleOnboardingStep
    );
    return () =>
      window.removeEventListener(
        ONBOARDING_STEP_CHANGED_EVENT,
        handleOnboardingStep
      );
  }, [setActiveDropdown]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        navRef.current &&
        event.target instanceof Node &&
        !navRef.current.contains(event.target)
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className={s.container}>
      <div
        className={s.burger}
        onClick={(event) => {
          event.stopPropagation();
          setActiveDropdown(isOpen ? null : 'navBar');
        }}
      >
        {isOpen ? <BurgerMenuOpen /> : <BurgerMenuClose />}
      </div>
      {pageTitle && <H1 className={s.title}>{pageTitle}</H1>}
      <NavBar ref={navRef} isOpen={isOpen} />
    </div>
  );
};
